import Containeritems from "./ContainerItems";
import ContainerItems2 from "./ContainerItems2";
import ContainerItems3 from "./ContainerItems3";
import React from 'react';


export default function ContainerItemsDefault({ id }) {
  const tourtradicional = [
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_city.png`}
          className="lg:w-[100%] xl:[80%] rounded-lg"
        />
      ),
      title: "TOUR MEDIO DIA",

      tour1:"CITY TOUR - MAÑANA",
      linktour1:"/tour-tradicional/citytour",
      tour2:"MARAS - MORAY",
      linktour2:"/tour-tradicional/maras-moray",
      tour3:"VALLE SUR",
      linktour3:"/tour-tradicional/valle-sur"

    },
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_valle.png`}
          className="w-[100%] rounded-lg"
        />
      ),
      title: "TOUR FULL DAY",
      tour1:"VALLE SAGRADO",
      linktour1:"/tour-tradicional/valle-sagrado",
      tour2:"VALLE VIP",
      linktour2:"/tour-tradicional/valle-vip",
      tour3:"CUSCO MISTICO",
      linktour3:"/tour-tradicional/cusco-mistico"
    },
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_laguna.png`}
          className="w-[100%] rounded-lg"
        />
      ),
      title: "TOUR TREK",
      tour1:"LAGUNA HUAMANTAY",
      linktour1:"/tour-tradicional/laguna-huamantay",
      tour2:"MONTAÑA 7 COLORES",
      linktour2:"/tour-tradicional/montania-colores",
      tour3:"MONTAÑA PALCOYO",
      linktour3:"/tour-tradicional/montania-palcoyo",
      tour4:"WAKRAPUKARA",
      linktour4:"/tour-tradicional/waqrapuka"

    },
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_aventura.png`}
          className="w-[100%] rounded-lg"
        />
      ),
      title: "TOUR AVENTURA",
      tour1:"CUATRIMOTOS MARAS MORAY",
      linktour1:"/tour-tradicional/cuatrimoto-maras-moray",
      //tour2:"CUATRIMOTOS MORADA DE DIOSES",
    },

  ];

  const tourmachupicchu = [
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_pro_cusco.png`}
          className="w-[100%] h-[140px] rounded-lg "
        />
      ),
      title: "PROGRAMA CUSCO",
      tour1:"CUSCO TRADICIONAL 4D/3N",
      tour2:"CUSCO CULTURAL 5D/4N",
      tour3:"CUSCO INCAICO 5D/4N",
      tour4:"CUSCO MULTICOLOR 7D/6N",
      tour5:"CUSCO MAGICO 8D/7N",
    },
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_especial.png`}
          className="w-[100%] h-[140px] rounded-lg "
        />
      ),
      title: "PROGRAMA ESPECIAL",
      tour1:"CUSCO - PUNO 7D/6N",
      tour2:"CUSCO - AREQUIPA 6D/5N",
      tour3:"CUSCO - PUNO - AREQUIPA 11D/10N",
    },
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_pro_peruano.png`}
          className="w-[100%] h-[140px] rounded-lg "
        />
      ),
      title: "PROGRAMA PERUANO",
      tour1:"MACHUPICCHU 7D/6N",
      tour2:"MACHUPICCHU 6D/5N",
      tour3:"MACHUPICCHU 11D/10N",
    },
  ];

  const touralternativo = [
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_camino_inca.png`}
          className="w-[100%] h-[140px] rounded-lg "
        />
      ),
      title: "CAMINO INCA",
      tour1:"CAMINO INCA 2D/1N",
      linktour1 : "/tour-trek/caminoinca2dx1n",
      tour2:"CAMINO INCA 4D/3N",
      linktour2: "/tour-trek/caminoinca4dx3n"
    },
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/nav_trek.png`}
          className="w-[100%] h-[140px] rounded-lg "
        />
      ),
      title: "TREKING",
      tour1:"SALKANTAY TREK 5D",
      linktour1:"/tour-trek/salkantayTrek5d",
      tour2:"SALKANTAY TREK 4D",
      linktour2:"/tour-trek/salkantayTrek4d",
      tour3:"CHOQUEQUIRAO 4D",
      linktour3:"/tour-trek/choquequirao4d",
      //tour4:"CHOQUEQUIRAO 4D/3N",
    },
  ];
  const trasnporte =[
    {
      src: (
        <img
          src={`${process.env.PUBLIC_URL}/images/cusco_valle_t.png`}
          className="w-[100%] h-[140px] rounded-lg "
        />
      ),
      title: "SERVICIO VIP TRASLADO",
      tour1:"TRASNPORTE OLLANTAYTAMBO - CUSCO",
      linktour1:"/transporte/ollantaytambo-cusco",
      tour2:"TRASNPORTE CUSCO - VALLE SAGRADO",
      linktour2:"/transporte/cusco-valle",
      tour3:"TRASNPORTE CUSCO - OLLANTAYTAMBO",
      linktour3:"/transporte/cusco-ollantaytambo",
      //tour4:"CHOQUEQUIRAO 4D/3N",
    },
  ];

  return (
    <>
      {id === 1 ? <Containeritems icons={tourtradicional} pack={4}/> : <></>}
      {id === 2 ? <ContainerItems3 icons={tourmachupicchu} pack={3}/> : <></>}
      {id === 3 ? <ContainerItems2 icons={touralternativo} pack={2}/> : <></>}
      {id === 4 ? <ContainerItems2 icons={trasnporte} pack={2}/> :<>/</> }
    </>
  );
}
